import superagent from 'superagent'

const fetchServiceInformationContent = async ({ setServiceInformationState }) => {
  try {
    const response = await superagent.get('/helpfaq-assets/static/data/faqs/72624.json')
    const { body = {} } = response || {}
    const content = body.answer || ''
    setServiceInformationState({ content, isLoading: false })
  } catch {
    const content = ''
    setServiceInformationState({ content, isLoading: false })
  }
}

export default fetchServiceInformationContent
